import {
  OPEN_SEARCHBOX_MODAL,
  CLOSE_SEARCHBOX_MODAL
} from "../constants/actionTypes";

export const openSearchboxWin = () => {
  return {
    type: OPEN_SEARCHBOX_MODAL
  };
};

export const closeSearchboxWin = () => {
  return {
    type: CLOSE_SEARCHBOX_MODAL
  };
};



// WEBPACK FOOTER //
// ./src/actions/generalActions.js